export default function Tabs(theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        indicator: {
          height: 3,
          borderRadius: '3px 3px 0 0',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          minHeight: 48,
          padding: theme.spacing(1.5, 3),
          '&:hover': {
            color: theme.palette.primary.main,
          },
          '&.Mui-selected': {
            fontWeight: 600,
          },
        },
      },
    },
  };
}

